import CircularProgress from '@mui/material/CircularProgress';
import { memo } from 'react';

interface Props {
  size?: number;
  thickness?: number;
  className?: string;
  color?: 'primary' | 'secondary' | 'inherit';
  variant?: 'indeterminate' | 'determinate';
}

const Component = memo((props: Props) => {
  return (
    <CircularProgress
      color={props.color}
      size={props.size}
      thickness={props.thickness}
      variant={props.variant}
      className={props.className}
    />
  );
});
export default Component;
